require('./movements.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ components
const MovementsTable = require('components/imposition/movements/movementsTable/movementsTable');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

class Movements extends React.Component {

    buildMovementsListContent() {
        let immMovementsList = this.props.immMovements.get('movementsList');
        let content = (
            <EmptyState primaryText={formatText('movements-emptyMovements')} withMargin={false} iconType="noitems-banking"/>
        );

        if (immMovementsList.size > 0) {
            content = (
                <MovementsTable immMovementsList={immMovementsList} />
            );
        }

        return content;
    }

    render() {

        const movementsListContent = this.buildMovementsListContent();
        let content;

        if (this.props.immMovements.get('isFetching')) {
            content = (<LoadingSection />);
        } else {
            content = (
                <Accordion isExpanded={true} customClassName="movements-section__accordion">
                    <AccordionHeader name="AccordionHeader">
                        <h3 className="movements-section__accordion-title">
                            <FormattedText value="movements-title" />
                        </h3>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div>
                            {movementsListContent}
                        </div>
                    </AccordionBody>
                </Accordion>
            );
        }
        return (
            <section className="movements-section">
                {content}
            </section>
        );
    }

}

Movements.propTypes = {
    immMovements: PropTypes.object.isRequired
};

module.exports = Movements;
